import {defineStore} from "pinia";
import api from "@/plugins/axios"

export const useProjectStore = defineStore('projects', {
    state: () => ({
        items: [],
        item: {}
    }),
    actions: {
        async getList() {
            try {
                const {data} = await api.get(`projects`);
                this.items = data;
            } catch (error) {
                console.error(error);
            }
        },
        async getById(id) {
            try {
                const {data} = await api.get(`projects/${id}`);
                this.item = data
            } catch (error) {
                console.error('Error fetching user details:', error);
            }
        },
        async create(item) {
            try {
                const {data} = await api.post(`projects`, item);
                this.item = data;
                return this.item
            } catch (error) {
                console.error('Error creating user:', error);
            }
        },
        async delete(id) {
            try {
                await api.delete(`projects/${id}`);
            } catch (error) {
                console.error('Error deleting user:', error);
            }
        },
        async update(id, item) {
            try {
                await api.patch(`projects/${id}`, {item});
            } catch (error) {
                console.error('Error updating user:', error);
            }
        },
    }
})
